import { CandidateInterviewTab } from '@/features/recruitment/components/candidate-interview-tab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/recruitment/candidates_/$id/interview')({
  component: InterviewTab,
});

function InterviewTab() {
  const { id } = Route.useParams();
  return <CandidateInterviewTab candidateId={id} />;
}
